import PropTypes from "prop-types";
import { Sparkles } from "lucide-react";

const EXAMPLE_QUESTIONS = [
  "Summarize my recent activity.",
  "Which certificates expire in the next 6 months?",
  "Compare these two properties.",
  "Which tasks are overdue and need attention?",
  "What changed on this property recently?",
  "Which properties are available and not leased?",
];

function AskAiEmptyState({ onSelectQuestion }) {
  return (
    <div className="flex min-h-full flex-col items-center justify-center gap-4 px-6 py-10 text-center">
      <span className="flex h-11 w-11 items-center justify-center rounded-full bg-accent/10 text-accent">
        <Sparkles size={20} aria-hidden="true" />
      </span>
      <div>
        <h3 className="text-base font-semibold text-text-primary">Ask AI about your portfolio</h3>
        <p className="mt-1 text-sm text-text-muted">
          Answers are grounded in your real properties, tasks, and activity — not invented.
        </p>
      </div>
      <div className="flex w-full flex-col gap-2">
        {EXAMPLE_QUESTIONS.map((question) => (
          <button
            key={question}
            type="button"
            onClick={() => onSelectQuestion(question)}
            className="rounded-lg border border-border bg-surface-raised px-3 py-2 text-left text-sm text-text-secondary transition hover:border-accent hover:text-text-primary focus:outline-none focus:ring-2 focus:ring-accent focus:ring-offset-2 focus:ring-offset-surface-raised"
          >
            {question}
          </button>
        ))}
      </div>
    </div>
  );
}

AskAiEmptyState.propTypes = {
  onSelectQuestion: PropTypes.func.isRequired,
};

export default AskAiEmptyState;
